import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 解决重复点击路由报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 公共路由
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  {
    path: "/",
    component: () => import("@/layouts/Layout"),
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "仪表板", icon: "el-icon-s-home" },
      },
    ],
  },
  {
    path: "/scenic-area",
    component: () => import("@/layouts/Layout"),
    redirect: "/scenic-area/list",
    name: "ScenicArea",
    meta: { title: "景区管理", icon: "el-icon-location" },
    children: [
      {
        path: "list",
        name: "ScenicAreaList",
        component: () => import("@/views/scenic-area/list"),
        meta: { title: "景区列表", icon: "el-icon-tickets" },
      },
      {
        path: "add",
        name: "ScenicAreaAdd",
        component: () => import("@/views/scenic-area/add"),
        meta: { title: "新增景区", activeMenu: "/scenic-area/list" },
        hidden: true,
      },
      {
        path: "edit/:id",
        name: "ScenicAreaEdit",
        component: () => import("@/views/scenic-area/edit"),
        meta: { title: "编辑景区", activeMenu: "/scenic-area/list" },
        hidden: true,
      },
      {
        path: "detail/:id",
        name: "ScenicAreaDetail",
        component: () => import("@/views/scenic-area/detail"),
        meta: { title: "景区详情", activeMenu: "/scenic-area/list" },
        hidden: true,
      },
    ],
  },
  {
    path: "/article",
    component: () => import("@/layouts/Layout"),
    redirect: "/article/list",
    name: "Article",
    meta: { title: "文章管理", icon: "el-icon-document" },
    children: [
      {
        path: "list",
        name: "ArticleList",
        component: () => import("@/views/article/list"),
        meta: { title: "文章列表", icon: "el-icon-tickets" },
      },
      {
        path: "add",
        name: "ArticleAdd",
        component: () => import("@/views/article/add"),
        meta: { title: "新增文章", activeMenu: "/article/list" },
        hidden: true,
      },
      {
        path: "edit/:id",
        name: "ArticleEdit",
        component: () => import("@/views/article/edit"),
        meta: { title: "编辑文章", activeMenu: "/article/list" },
        hidden: true,
      },
      {
        path: "detail/:id",
        name: "ArticleDetail",
        component: () => import("@/views/article/detail"),
        meta: { title: "文章详情", activeMenu: "/article/list" },
        hidden: true,
      },
    ],
  },
  {
    path: "/user",
    component: () => import("@/layouts/Layout"),
    redirect: "/user/list",
    name: "User",
    meta: { title: "用户管理", icon: "el-icon-user" },
    children: [
      {
        path: "list",
        name: "UserList",
        component: () => import("@/views/user/list"),
        meta: { title: "用户列表", icon: "el-icon-user-solid" },
      }
    ],
  },
  {
    path: "/system",
    component: () => import("@/layouts/Layout"),
    redirect: "/system/logs",
    name: "System",
    meta: { title: "系统管理", icon: "el-icon-setting" },
    children: [
      {
        path: "logs",
        name: "SystemLogs",
        component: () => import("@/views/system/logs"),
        meta: { title: "系统日志", icon: "el-icon-document" },
      },
    ],
  },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
